import { CompanyFields } from '../../../../common/enums';

export const DEFAULT_COMPANY_SORT = {
    field: CompanyFields.name,
    direction: 1,
};
